/* ==========================================================================
   Main Application Entry Point
   Initializes tab navigation, state subscriptions, and sub-controllers
   ========================================================================== */

import { appState } from './state.js';
import { initHome } from './home.js';
import { initArsenal } from './arsenal.js';
import { initVisualizer } from './visualizer.js';
import { initLeagueSecretary } from './leagueSecretary.js';
import { initProShopSpecs } from './proShopSpecs.js';
import { initStats } from './stats.js';
import { initUserSync } from './userSync.js';

document.addEventListener('DOMContentLoaded', () => {
  // Initialize Lucide Icons
  if (window.lucide) {
    window.lucide.createIcons();
  }

  // Navigation Controller
  const navBtns = document.querySelectorAll('.bottom-nav .nav-btn');
  const tabPanes = document.querySelectorAll('.tab-pane');

  function switchTab(targetTabId) {
    appState.set({ activeTab: targetTabId });

    navBtns.forEach(btn => {
      const tab = btn.getAttribute('data-tab');
      btn.classList.toggle('active', tab === targetTabId);
    });

    tabPanes.forEach(pane => {
      pane.classList.toggle('active', pane.id === targetTabId);
    });

    // Dispatch resize event so canvas visualizer redraws when visible
    window.dispatchEvent(new Event('resize'));

    // Scroll content view back to top
    const appContent = document.querySelector('.app-content');
    if (appContent) appContent.scrollTop = 0;
  }

  navBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const tabId = btn.getAttribute('data-tab');
      switchTab(tabId);
    });
  });

  // Header actions
  const btnQuickNote = document.getElementById('quickAddNoteBtn');
  if (btnQuickNote) {
    btnQuickNote.addEventListener('click', () => {
      const modalNote = document.getElementById('noteModal');
      if (modalNote) modalNote.classList.remove('hidden');
    });
  }

  // Initialize Modules
  initUserSync();
  initHome();
  initArsenal();
  initVisualizer();
  initStats();
  initLeagueSecretary();
  initProShopSpecs();

  // Restore active tab from state
  const initialTab = appState.get().activeTab || 'tab-home';
  switchTab(initialTab);
});
